import PropTypes from 'prop-types';

function ChartLegendRow({ color = '', name = '', count = 0, valueFormatter = () => {}, isHighlighted = false }) {
  const rowClassName = `ChartLegend-row${isHighlighted ? ' ChartLegend-row--highlighted' : ''}`;

  return (
    <div className={rowClassName}>
      <div className="ChartLegend-swatchContainer">
        <div className="ChartLegend-swatch" style={{ backgroundColor: color }} />
      </div>
      <div className="ChartLegend-nameContainer">
        <div>{name}</div>
      </div>
      <div className="ChartLegend-countContainer">
        <div className="ChartLegend-count">{valueFormatter(count)}</div>
      </div>
    </div>
  );
}

ChartLegendRow.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.number,
  valueFormatter: PropTypes.func,
  isHighlighted: PropTypes.bool,
};

export default ChartLegendRow;
